// Copyright © 2021 Move Closer
import { TokenType } from '@d24/demarked';
import { ModuleDriver } from '../_contracts';
import { getModuleBase } from '../_helpers/adapter';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export class HeadingAdapter {
    /**
     * Adapts (translates/maps) the passed-in `HeadingModule` to the `HeadingToken`.
     *
     * @param object - The module to adapt.
     */
    objectToToken(object) {
        const { content } = object;
        if (typeof content !== 'object') {
            throw new Error(`HeadingAdapter.objectToToken(): [object.content] property should be an [object], but got ${typeof content}!\nFull [object] object: ${JSON.stringify(object)}`);
        }
        const { level, text } = content;
        if (typeof level !== 'number') {
            throw new Error(`HeadingAdapter.objectToToken(): [object.content.level] property should be a [number], but got ${typeof level}!\nFull [object] object: ${JSON.stringify(object)}`);
        }
        if (typeof text !== 'string') {
            throw new Error(`HeadingAdapter.objectToToken(): [object.content.text] property should be a [string], but got ${typeof text}!\nFull [object] object: ${JSON.stringify(object)}`);
        }
        let raw = ` ${text}`;
        for (let i = 0; i < level; i++) {
            raw = `#${raw}`;
        }
        return {
            content: text,
            meta: { level },
            raw,
            type: TokenType.Heading
        };
    }
    /**
     * Adapts (translates/maps) the passed-in `HeadingToken` to the `HeadingModule`.
     *
     * @param token - The token to adapt.
     */
    tokenToObject(token) {
        const { content: text, meta } = token;
        if (typeof text !== 'string') {
            throw new Error(`HeadingAdapter.tokenToObject(): [token.content] property should be a [string], but got [${typeof text}]!\nFull [token] object: ${JSON.stringify(token)}`);
        }
        if (typeof meta === 'undefined') {
            throw new Error(`HeadingAdapter.tokenToObject(): [token.meta] property is missing!\nFull [token] object: ${JSON.stringify(token)}`);
        }
        const { level } = meta;
        if (typeof level !== 'number') {
            throw new Error(`HeadingAdapter.tokenToObject(): [token.meta.level] property should be a [number], but got [${typeof level}]!\nFull [token] object: ${JSON.stringify(token)}`);
        }
        return {
            ...getModuleBase(),
            content: { level, text },
            driver: ModuleDriver.Heading
        };
    }
}
